<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<style>
* {
  font-family: "Poppins", sans-serif !important;
}

.v-navigation-drawer__content {
  scrollbar-width: thin !important;
  /* Firefox */
  scrollbar-color: lightgray !important;
}

.cursorPointer {
  cursor: pointer !important;
}

.fontVariant0 {
  font-size: 10px !important;
}

.fontVariant1 {
  font-size: 12px !important;
}

.fontVariant2 {
  font-size: 14px !important;
}

.fontVariant3 {
  font-size: 16px !important;
}

.fontVariant4 {
  font-size: 18px !important;
}

.fontVariant5 {
  font-size: 20px !important;
}

.greyTextNavTitle {
  color: #eef2f6 !important;
}

.field_height .v-field {
  min-height: 12px !important;
  max-height: 33px !important;
  display: flex !important;
  align-items: center !important;
}

.field_label_size.v-input .v-label {
  font-size: 10px !important;
  opacity: 1 !important;
}

.field_font .v-field__input {
  font-size: 12px !important;
}

.radio_buttons_label.v-input .v-label {
  font-size: 12px !important;
  opacity: 1 !important;
}

.radio_buttons_field_font .v-field__input {
  font-size: 12px !important;
}

.hover_SelectedItem:hover {
  background-color: #96bfe9 !important;
}

.v-selection-control .v-label {
  font-size: 14px !important;
}

.v-calendar-month__day {
  min-height: 10px !important;
}

.searchFieldHeight1 .v-field {
  min-height: 12px !important;
  max-height: 27px !important;
  display: flex !important;
  align-items: center !important;
}

/* .cardOutlined {
  border: 2px solid white !important;
} */

.textTruncate {
  width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.hoverVList:hover {
  background-image: linear-gradient(#f6faff, #d5d7dd);
  cursor: pointer !important;
}

.v-badge__badge {
  font-size: 10px !important;
  text-align: center !important;
}

.v-messages__message {
  font-size: 10px !important;
  padding: 0px !important;
}

.text-red {
  color: red !important;
}

.text-underline {
  text-decoration: underline !important;
}

.disabledCardClass {
  pointer-events: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  user-select: none !important;
}
</style>
